module.exports = __webpack_public_path__ + "img/intro_phone3.d6a501e2.png";